<!-- <ng-container *ngIf="getVisibility()"> -->
<ng-container *ngIf="getVisibility(title)">
  <div class="col-md-12 underline margin-top-30"></div>
  <div class="col-md-12 clear-all content-sub-wrapper-new common margin-top-30">
    <div class="col-md-12 clear-all header">
      <div class="col-md-9 text-left padding-right-0 margin-bottom">
        <p class="line-height" id="{{getId(title)}}" class="inner-title" *ngIf="titleFlag === true">
          {{getTitle(title)}}&nbsp;&nbsp;
          <i class="icon icon-tick" aria-hidden="true"></i>
        </p>
        <p class="line-height" id="{{getId(title)}}" class="inner-title" *ngIf="titleFlag === false">{{getTitle(title)}}
        </p>
      </div>
      <div class="col-md-3 text-right"
        *ngIf="(getId(title) === 'yourPersonalDetails' && registrationStatus && isEdit) || (getId(title) != 'yourPersonalDetails' && isEdit)">
        <button id="edit-btn-{{getId(title)}}" class="btn btn-secondary btn-sm Centre" type="button"
          (click)="gotoEdit(onClickGoTo)">{{reviewLabel}}</button>
      </div>
    </div>
    <ng-container
      *ngIf="(productCode === 'C' || (productCode === 'H' && title != 'Your pension annuity options' ) || (productCode === 'G' && title != 'Your pension annuity options' ))  ">
      <dl class="col-md-12 clear-all">
        <ng-container *ngFor="let section of dataList;let i=index">
          <!-- <div class="col-md-12 clear-all"> -->
          <ng-container *ngIf="getTitleFlag(section,title,fieldValues[section.storeControlName],fieldValues)">
            <dl class="row clear-all flex-container">
              <dt class="col-md-5 field flex-50">
                <small class="font-weight"
                  id="{{getId(title)}}-{{section.storeControlName}}-name">{{getLabel(section.label)}} :</small>
              </dt>
              <dd class="col-md-7 field flex-50">
                <small
                  id="{{getId(title)}}-{{section.storeControlName}}-value">{{fieldValues[section.storeControlName]?formatInput(title,
                  section.label, fieldValues[section.storeControlName],
                  fieldValues): throwEmpty(fieldValues[section.storeControlName], section.label, title,
                  fieldValues,i,section.storeControlName)}}</small>
              </dd>
            </dl>
          </ng-container>
          <!--</div> -->
        </ng-container>
        <div class="col-md-12 margin-top-30 clear-all" *ngIf="medicalConditionStaticMsg && 
        ((dependantMedicalConditionInfo && 
        title === cmsData1.yourDependantsMedicalConditions) 
            || (medicalConditionInfo && title === cmsData1.yourMedicalConditions))">
          <div class="col-md-12 bg-lightblue field">
            <small class="font-weight">
              {{medicalConditionStaticMsg}}
            </small>
          </div>
        </div>
        <div class="col-md-12 newUserLogin" *ngIf="getId(title) === 'yourPersonalDetails' && !registrationStatus">
          <small class="font-weight">{{cmsData1.newUserReview}}</small>
        </div>
      </dl>
    </ng-container>


    <ng-container *ngIf="productCode === 'H' && title =='Your pension annuity options'">
      <dl class="col-md-12 clear-all">
        <ng-container *ngFor="let section of ftrpDataList;let i=index">
          <!-- <div class="col-md-12 clear-all"> -->
          <ng-container *ngIf="getTitleFlag(section,title,fieldValues[section.storeControlName],fieldValues)">
            <dl class="row clear-all flex-container">
              <dt class="col-md-5 field flex-50">
                <small class="font-weight"
                  id="{{getId(title)}}-{{section.storeControlName}}-name">{{getLabel(section.label)}} :</small>
              </dt>
              <dd class="col-md-7 field flex-50">
                <small
                  id="{{getId(title)}}-{{section.storeControlName}}-value">{{fieldValues[section.storeControlName]?formatInput(title,
                  section.label, fieldValues[section.storeControlName],
                  fieldValues): throwEmpty(fieldValues[section.storeControlName], section.label, title,
                  fieldValues,i,section.storeControlName)}}</small>
              </dd>
            </dl>
          </ng-container>
          <!--</div> -->
        </ng-container>
      </dl>
    </ng-container>

    <ng-container *ngIf="productCode === 'G' && title =='Your pension annuity options'">
      <dl class="col-md-12 clear-all">
        <ng-container *ngFor="let section of corpDataList;let i=index">
          <!-- <div class="col-md-12 clear-all"> -->
          <ng-container *ngIf="getTitleFlag(section,title,fieldValues[section.storeControlName],fieldValues)">
            <div class="flex-container">
              <dt class="col-md-5 field flex-50">
                <small class="font-weight"
                  id="{{getId(title)}}-{{section.storeControlName}}-name">{{getLabel(section.label)}} :</small>
              </dt>
              <dd class="col-md-7 field flex-50">
                <small
                  id="{{getId(title)}}-{{section.storeControlName}}-value">{{fieldValues[section.storeControlName]?formatInput(title,
                  section.label, fieldValues[section.storeControlName],
                  fieldValues): throwEmpty(fieldValues[section.storeControlName], section.label, title,
                  fieldValues,i,section.storeControlName)}}</small>
              </dd>
            </div>
          </ng-container>
        </ng-container>
      </dl>
    </ng-container>

    <ng-container *ngIf="storeName !== 'beneficiaryDetails' && storeName !== 'pensionSavings';else PensionSavings">


      <!-- <div class="col-md-12 clear-all"></div> -->
       <div class="row"></div>
      <dl class="col-md-12 clear-all">

        <ng-container *ngFor="let section of summmaryDataList;let i=index">

          <!--<div class="col-md-12 clear-all"> -->
          <ng-container *ngIf="getTitleFlag(section,title,fieldValues[section.storeControlName],fieldValues)">
            <dl class="flex-container" *ngIf="section.storeControlName!='lifeTimeAllowance' else showlifeAllowance">
              <dt class="col-md-5 field flex-50">
                <small class="font-weight"
                  id="{{getId(title)}}-{{section.storeControlName}}-name">{{getLabel(section.label)}} :</small>
              </dt>
              <dd class="col-md-7 field flex-50">
                <small
                  id="{{getId(title)}}-{{section.storeControlName}}-value">{{fieldValues[section.storeControlName]?formatInputApply(title,
                  section.label, fieldValues[section.storeControlName],
                  fieldValues): throwEmpty(fieldValues[section.storeControlName], section.label, title,
                  fieldValues,i,section.storeControlName)}}</small>
              </dd>
            </dl>
            <ng-template #showlifeAllowance>
              <ng-container *ngIf="showContentLabel">
                <dl class="flex-container">
                  <dt class="col-md-5 field flex-50">
                    <small class="font-weight"
                      id="{{getId(title)}}-{{section.storeControlName}}-name">{{getLabel(section.label)}} :</small>
                  </dt>
                  <dd class="col-md-7 field flex-50">
                    <small
                      id="{{getId(title)}}-{{section.storeControlName}}-value">{{fieldValues[section.storeControlName]?formatInputApply(title,
                      section.label, fieldValues[section.storeControlName],
                      fieldValues): throwEmpty(fieldValues[section.storeControlName], section.label, title,
                      fieldValues,i,section.storeControlName)}}</small>
                  </dd>
                </dl>
              </ng-container>
            </ng-template>
          </ng-container>
        </ng-container>
      </dl>
    </ng-container>
    <ng-template #PensionSavings>
      <p *ngIf="storeName == 'beneficiaryDetails' && fieldValues?.length == 0" class="beneficiaryTitle">
        None selected
      </p>
      <div *ngFor="let fieldVal of fieldValues; let i=index;">
        <p *ngIf="storeName == 'beneficiaryDetails'" class="beneficiaryTitle"> Beneficiary {{i+1}}</p>
        <!-- <div class="col-md-12 clear-all"></div> -->
         <div class="row"></div>
        <ng-container *ngFor="let section of summmaryDataList;let i=index">

          <ng-container *ngIf="getTitleFlag(section,title,fieldVal[section.storeControlName],fieldValues)">
            <div class="flex-container">
              <div class="col-md-5 field flex-50">
                <small class="font-weight"
                  id="{{getId(title)}}-{{section.storeControlName}}-name">{{getLabel(section.label)}} :</small>
              </div>
              <div class="col-md-7 field flex-50">

                <small id="{{getId(title)}}-{{section.storeControlName}}-value"
                  *ngIf="section.label == 'Tax-free cash' && fieldVal['extTfcAmt'] && fieldVal['extTfcAmt']!==null && 
                    fieldValues['extTfcAmt'] !== '0' else showTFC">{{fieldVal['extTfcAmt']?formatInputApply(title,
                  section.label, fieldVal['extTfcAmt'],
                  fieldVal): throwEmpty(fieldVal['extTfcAmt'], section.label, title, fieldVal,i,'extTfcAmt')}}
                </small>
                <ng-template #showTFC>
                  <small
                    id="{{getId(title)}}-{{section.storeControlName}}-value">{{fieldVal[section.storeControlName]?formatInputApply(title,
                    section.label, fieldVal[section.storeControlName],
                    fieldVal):throwEmpty(fieldVal[section.storeControlName], section.label, title,
                    fieldVal,i,section.storeControlName)}}
                  </small>
                </ng-template>

              </div>
            </div>
          </ng-container>
        </ng-container>
      </div>
    </ng-template>
  </div>
</ng-container>
<app-modal *ngIf="isLocked" [modalConfig]="lockedAlertModalConfig" (closeModal)="closeLockedModal()"
  (primaryBtnClick)="closeLockedModal()" [saveDataFlag]="false">
</app-modal>
<!-- </ng-container> -->